// extracted by mini-css-extract-plugin
module.exports = {"root":"Debugger_root__10Qgg","openBtn":"Debugger_openBtn__2fdE6"};